import {auth} from "@/firebase/init"

export default {
	data: function () {
		return {
			countRequests: 0
		}
	},
	computed: {
		userToken() {
			return this.$store.getters.getUserToken;
		},
		user() {
			return this.$store.getters.user;
		}
	},
	methods: {
		refreshToken() {
			return true;
			// auth.currentUser.getIdToken(true).then((idToken) => {
			// 	this.$store.dispatch('updateUserDetails', {...this.user, idToken: idToken})
			// 	localStorage.setItem('userDtls', JSON.stringify({...this.user, idToken: idToken}))
            //     //callback();
			// })
		}
	}
}
